/**
 * Iter-156B Phase 1 — Visibility pill for content rows + detail
 * headers.
 *
 * Shown only when visibility is tighter than "Project Team" — keeps
 * the default case visually quiet. Calm sky-tinted chip with a tiny
 * eye-off-style cue so users instantly understand "this is scoped".
 *
 * The pill is read-only by design — the editable picker is a
 * separate <VisibilityPicker /> control. This component is for
 * lists, rollups and detail-header status.
 */
import { Lock, ShieldCheck } from "lucide-react";
import { visibilityPillLabel } from "../lib/visibility";

export default function VisibilityPill({ value, testid, className = "" }) {
    if (!value || value === "everyone") return null;
    const Icon = value === "uploader_only" ? Lock : ShieldCheck;
    return (
        <span
            data-testid={testid || "visibility-pill"}
            data-visibility={value}
            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] text-sky-200 bg-sky-500/15 border border-sky-500/30 rounded-full px-1.5 py-0.5 font-semibold ${className}`}
        >
            <Icon size={9} />
            {visibilityPillLabel(value)}
        </span>
    );
}
